import { useEffect, useState } from 'react'
import FilterItem from 'components/Osearch/FilterItem'

const Filters = ({
  phoneTypeOptions,
  manufacturerOptions,
  modelOptions,
  selectedPhoneFilter,
  selectedManufacturerFilter,
  selectedModelFilter,
  getOption,
  onChangeFilters
}) => {
  const typeLabel = getOption('search.typeLabel', 'Type')
  const manufacLabel = getOption('search.manufacturerLabel', 'Manufacturer')
  const modelLabel = getOption('search.modelLabel', 'Model')

  const [selectedType, setSelectedType] = useState('')
  const [selectedManufac, setSelectedManufac] = useState('')
  const [selectedModel, setSelectedModel] = useState('')

  const notifyChange = (type, value) => {
    let nextType = selectedType
    let nextManufac = selectedManufac
    let nextModel = selectedModel
    if (type === 'phone_type') nextType = value
    if (type === 'manufacturer') nextManufac = value
    if (type === 'model') nextModel = value

    onChangeFilters({
      ...(nextType && { phone_type: nextType }),
      ...(nextManufac && { manufacturer: nextManufac }),
      ...(nextModel && { model: nextModel })
    })
  }

  useEffect(() => { 
    setSelectedType(selectedPhoneFilter)
    notifyChange('phone_type', selectedPhoneFilter)
  }, [selectedPhoneFilter])

  useEffect(() => {
    setSelectedManufac(selectedManufacturerFilter)
    notifyChange('manufacturer', selectedManufacturerFilter)
  }, [selectedManufacturerFilter])

  useEffect(() => {
    setSelectedModel(selectedModelFilter)
    notifyChange('model', selectedModelFilter)
  }, [selectedModelFilter])

  return (
    <div>
      <FilterItem
        title={typeLabel}
        name="phone_type"
        options={phoneTypeOptions ?? []}
        selected={selectedType}
        onChange={value => {
          setSelectedType(value)
          notifyChange('phone_type', value)
        }}
      />
      <FilterItem
        title={manufacLabel}
        name="manufacturer"
        options={manufacturerOptions ?? []}
        selected={selectedManufac}
        onChange={value => {
          setSelectedManufac(value)
          notifyChange('manufacturer', value)
        }}
      />
      <FilterItem
        title={modelLabel}
        name="model"
        options={modelOptions ?? []}
        selected={selectedModel}
        onChange={value => {
          setSelectedModel(value)
          notifyChange('model', value)
        }}
      />
    </div>
  )
}

export default Filters
